import React, {useEffect, useState} from 'react';
import Header from '~/components/header/Header';
import Block from '~/components/ui/block/Block';
import Button from '~/components/ui/button/Button';
import { styled, keyframes } from "styled-components";
import apiService from '~/service/apiService';
import Anonymous from '~/components/anonymous/Anonymous';
import LoadingIcon from '~/assets/loading.svg';

const PublishBlock = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  
  .buttonGroup {
    margin-top: 20px;
    button {
      width: 200px;
      margin-left: 10px;
      margin-right: 10px;
    }
  }
  
  .conteinerForIframe {
    aspect-ratio: 13 / 5;
    width: 100%;
    overflow: hidden;
  }
  
  .previewIframe {
    border: none;
    border-width: 0px;
    width: 100%;
    aspect-ratio: 13 / 7;
    transform: scale(0.7);
    margin-left: auto;
    margin-right: auto;
    display: block;
    transform-origin: 50% 0;
  }
  .instruction {
    color: red;
    padding: 10px;

    color: #000;
    font-variant-numeric: lining-nums proportional-nums;
    
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%
  }
`;

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

const Loading = styled.div`
  width: 40px;
  height: 40px;
  background: url(${LoadingIcon}) no-repeat center center;
  background-size: cover;
  animation: ${rotate} 2s linear infinite;
  margin-left: auto;
  margin-right: auto;
  position: relative;
  top: 40%;
`;

const Publish = ({jwt, activeStep, btnBackEvent, companyId, trainingId}) => {

  const [url, setUrl] = useState();
  const [status, setStatus] = useState('draft');
  const [trainingName, setTrainingName] = useState('');
  const [showAnonymous, setShowAnonymous] = useState(true);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);

    apiService.get(`/companies/${companyId}/trainings/${trainingId}`, jwt).then(data => {
      if (data && data.training) {
        setTrainingName(data.training.title);
      }

      if (data && data.training && data.training.status) {
        setStatus(data.training.status);

        if (data.training.status !== 'draft') {
          setShowAnonymous(false);
        }
      }

      if (data && data.training && data.training.sequences && data.training.sequences[0]) {
        const firstSequence = data.training.sequences[0];

        if (firstSequence && firstSequence.previewUrl) {
          setLoading(false);

          if (data.training.firstCustomizableSequenceId) {
            const parts = firstSequence.previewUrl.split('/');
            parts[parts.length - 1] = data.training.firstCustomizableSequenceId;
            const newPreviewUrl = parts.join('/');
            setUrl(newPreviewUrl);
          } else {
            setUrl(firstSequence.previewUrl);
          }
        }
      }
    });
  }, [jwt, companyId, trainingId]);

  const PublishTraining = () => {
    apiService.patch(`/companies/${companyId}/trainings/${trainingId}/publish`, {}, jwt).then(data => {
      if (data && data.training && data.training && data.training.status) {
        if (data.training.status === 'live' && data.training.redirectUrl) {
          window.location.href = data.training.redirectUrl;
        }
      }
    });
  };

  return (
    <div className='wizardWrapper'>
      <div className='header'>
        <Header activeStep={activeStep} title={trainingName} />
      </div>
      <div className='wz_container'>
        {showAnonymous ? <Anonymous skipEvent={() => setShowAnonymous(false)} /> : (
          <Block>
            <PublishBlock>
              <h2 style={{fontFamily: 'Recoleta'}}>Preview</h2>
              <div className='conteinerForIframe'>
                {url && <iframe
                  title='Training'
                  className='previewIframe'
                  src={url} ></iframe>}
                {loading && <Loading />}
              </div>
              <div className='instruction'>
                Please review your customized slides within their respective chapters. Please note that you will also be able to preview the course in its entirety after you have completed this step. If additional edits are needed, select the back button. If you are happy with your customized slides, select Publish!
              </div>
              <div className='buttonGroup'>
                <Button title='Back' onClick={btnBackEvent} />
                <Button title={status === 'draft' ? 'Publish' : 'Save'} onClick={PublishTraining} className='primaryBtn' />
              </div>
            </PublishBlock>
          </Block>
        )}
      </div>
    </div>
  );
};

export default Publish;
